window.HighlightsRisksFeatureSection = function() {
	return {
		state: {
			plotObj: null,
			plotData: [
				{
					label: "",
					data:[
						[0,"77.32"],[1,"69.5"],[2,"66.47"],[3,"68.53"],[4,"66.15"],[5,"61.6"],[6,"58.32"],[7,"49.81"],[8,"51.62"],[9,"48.02"],[10,"50.14"],[11,"52.44"],[12,"51.67"],[13,"49.4"],[14,"48.71"],[15,"47.2"],[16,"34.73"],[17,"33.32"],[18,"35.0"],[19,"36.33"],[20,"33.25"],[21,"33.17"],[22,"39.7"],[23,"41.25"],[24,"39.95"],[25,"44.03"],[26,"43.76"],[27,"46.23"],[28,"48.5"],[29,"50.62"],[30,"53.15"],[31,"49.25"],[32,"49.58"],[33,"49.96"],[34,"53.07"],[35,"53.99"],[36,"55.68"],[37,"54.0"],[38,"51.87"],[39,"52.39"],[40,"50.92"],[41,"50.08"],[42,"50.07"],[43,"49.06"],[44,"49.29"],[45,"52.54"],[46,"52.98"],[47,"52.49"],[48,"53.57"],[49,"55.06"],[50,"63.63"],[51,"69.85"],[52,"69.56"],[53,"68.3"],[54,"61.37"],[55,"58.55"],[56,"61.62"],[57,"65.61"],[58,"66.68"],[59,"69.5"],[60,"68.31"],[61,"62.64"],[62,"58.11"],[63,"51.84"],[64,"42.91"],[65,"45.94"],[66,"49.83"],[67,"51.62"],[68,"49.43"],[69,"45.18"],[70,"47.72"],[71,"52.62"],[72,"53.75"],[73,"52.14"],[74,"52.84"],[75,"54.11"],[76,"52.9"],[77,"53.61"]
					],
					color: "#dfe0e1",
					lines: {
						lineWidth: 1,
						show: true
					},
					yaxis: 3
				},
				{
					label: "",
					data:[
						[0,"77.32"],[1,"69.5"],[2,"66.47"],[3,"68.53"],[4,"66.15"],[5,"61.6"],[6,"58.32"],[7,"49.81"],[8,"51.62"],[9,"48.02"],[10,"50.14"],[11,"52.44"],[12,"51.67"],[13,"49.4"],[14,"48.71"],[15,"47.2"],[16,"34.73"],[17,"33.32"],[18,"35.0"],[19,"36.33"],[20,"33.25"],[21,"33.17"],[22,"39.7"],[23,"41.25"],[24,"39.95"],[25,"44.03"],[26,"43.76"],[27,"46.23"],[28,"48.5"],[29,"50.62"],[30,"53.15"],[31,"49.25"],[32,"49.58"],[33,"49.96"],[34,"53.07"],[35,"53.99"],[36,"55.68"],[37,"54.0"],[38,"51.87"],[39,"52.39"],[40,"50.92"],[41,"50.08"],[42,"50.07"],[43,"49.06"],[44,"49.29"],[45,"52.54"],[46,"52.98"],[47,"52.49"],[48,"53.57"],[49,"55.06"],[50,"63.63"],[51,"69.85"],[52,"69.56"],[53,"68.3"],[54,"61.37"],[55,"58.55"],[56,"61.62"],[57,"65.61"],[58,"66.68"],[59,"69.5"],[60,"68.31"],[61,"62.64"],[62,"58.11"],[63,"51.84"],[64,"42.91"],[65,"45.94"],[66,"49.83"],[67,"51.62"],[68,"49.43"],[69,"45.18"],[70,"47.72"],[71,"52.62"],[72,"53.75"],[73,"52.14"],[74,"52.84"],[75,"54.11"],[76,"52.9"],[77,"53.61"]
					],
					color: "#9fa0a1",
					lines: {
						lineWidth: 1,
						show: true
					},
					yaxis: 2
				},
				{
					label: "",
					data:[
						[0,"77.32"],[1,"69.5"],[2,"66.47"],[3,"68.53"],[4,"66.15"],[5,"61.6"],[6,"58.32"],[7,"49.81"],[8,"51.62"],[9,"48.02"],[10,"50.14"],[11,"52.44"],[12,"51.67"],[13,"49.4"],[14,"48.71"],[15,"47.2"],[16,"34.73"],[17,"33.32"],[18,"35.0"],[19,"36.33"],[20,"33.25"],[21,"33.17"],[22,"39.7"],[23,"41.25"],[24,"39.95"],[25,"44.03"],[26,"43.76"],[27,"46.23"],[28,"48.5"],[29,"50.62"],[30,"53.15"],[31,"49.25"],[32,"49.58"],[33,"49.96"],[34,"53.07"],[35,"53.99"],[36,"55.68"],[37,"54.0"],[38,"51.87"],[39,"52.39"],[40,"50.92"],[41,"50.08"],[42,"50.07"],[43,"49.06"],[44,"49.29"],[45,"52.54"],[46,"52.98"],[47,"52.49"],[48,"53.57"],[49,"55.06"],[50,"63.63"],[51,"69.85"],[52,"69.56"],[53,"68.3"],[54,"61.37"],[55,"58.55"],[56,"61.62"],[57,"65.61"],[58,"66.68"],[59,"69.5"],[60,"68.31"],[61,"62.64"],[62,"58.11"],[63,"51.84"],[64,"42.91"],[65,"45.94"],[66,"49.83"],[67,"51.62"],[68,"49.43"],[69,"45.18"],[70,"47.72"],[71,"52.62"],[72,"53.75"],[73,"52.14"],[74,"52.84"],[75,"54.11"],[76,"52.9"],[77,"53.61"]
					],
					color: "#434343",
					lines: {
						lineWidth: 2,
						show: true
					}
				}
			]
		},
		setState: function(state) {
			for (var key in state) {
				if (!this.state.hasOwnProperty(key)) {
					continue;
				}

				this.state[key] = state[key];
				switch (key) {
					case "plotObj":
						break;
					default:

				}
			}
		},
		el: $(".highlights-risks-feature-section"),
		renderPlot: function() {
			if (this.state.plot == null) {
				var obj = this.state.plotData;

				var plotObj = this.el.find(".highlights-risks-feature-plot");
				this.setState({plotObj: $.plot(plotObj, this.state.plotData,{
						series	:{
							shadowSize: 0
						},
						grid	:{
							show: false
						},
						legend	: {
							show: false
						},
						xaxis	:{
							show: false
						},
						yaxes: [
							{
								show: false
							},
							{
								show: false,
								max: 93,
								min: 30
							},
							{
								show: false,
								max: 120,
								min: 24
							}
						]
					})
				});

				plotObj.resize();
			}
		},
		init: function() {
			if (this.el.find(".highlights-risks-feature-plot").length === 0) {
				return;
			}

			this.renderPlot();
		}
	}
}
